"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const root_1 = require("react-hot-loader/root");
const components_1 = require("../../shared/src/components");
const LoadingScreen_1 = __importDefault(require("../../shared/src/components/LoadingScreen/LoadingScreen"));
const honest_react_1 = require("@digitools/honest-react");
const EnvUtils_1 = require("../../shared/src/utils/EnvUtils");
const Auth0Provider_1 = __importDefault(require("../../shared/src/providers/Auth0Provider"));
const styled_components_1 = require("@digitools/honest-react/dist/lib/theming/styled-components");
const themes_1 = __importDefault(require("@digitools/honest-react/dist/lib/theming/themes"));
const LandingPage = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('./components/LandingPage'))));
const UnauthorizedPage = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('./components/Unauthorized'))));
const auth0RedirectUri = (0, EnvUtils_1.getEnvVariable)('auth0RedirectUri');
const ProtectedRouter = () => ((0, jsx_runtime_1.jsx)(Auth0Provider_1.default, { redirectUri: auth0RedirectUri, redirectPathname: '/callback', successFallbackUrl: '/', children: (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { exact: true, path: '/', component: LandingPage }) }));
const PublicRouter = () => (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: '/public/unauthorized', component: UnauthorizedPage });
const App = () => ((0, jsx_runtime_1.jsx)(styled_components_1.ThemeProvider, { theme: themes_1.default.default, children: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(components_1.Header, {}), (0, jsx_runtime_1.jsx)(react_router_dom_1.BrowserRouter, { children: (0, jsx_runtime_1.jsx)(react_1.Suspense, { fallback: (0, jsx_runtime_1.jsx)(LoadingScreen_1.default, {}), children: (0, jsx_runtime_1.jsx)(honest_react_1.Container, { className: 'mt-5', children: (0, jsx_runtime_1.jsxs)(react_router_dom_1.Switch, { children: [(0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: '/public', component: PublicRouter }), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: '/', component: ProtectedRouter })] }) }) }) })] }) }));
// Note: hot wont do anything in production mode
exports.default = (0, root_1.hot)(App);
